export default "__VITE_ASSET__K0FMGusb__"